import WealthBreakdownContainer from './wealth-breakdown-container'
import './wealth-breakdown.styl'

export { WealthBreakdownContainer }



// WEBPACK FOOTER //
// ./sections/wealth-breakdown/index.js